import React, { useEffect, useState } from 'react';
import { Container, Alert, Spinner, Card, Button, Row, Col } from 'react-bootstrap';
import { DataManager } from '../core/data-manager';
import { LoginManager } from '../core/login-manager';
import { LanguageProvider } from '../core/language-provider';


export default function Dashboard() {

    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const userInfo = LoginManager.getUserInfo();

    useEffect(() => {
        async function init() {
            var userInfo = await LoginManager.getUserInfo()

        }
        init()

    }, []);



    return (
        <>
            {userInfo.level === 1 ? <>
                <Container fluid className='my-3'>
                    <Alert show={true} variant="primary">
                        <Alert.Heading>E-Library Fedespedi</Alert.Heading>
                        <p>
                            Clicca nel pulsante qui sotto per accedere a E-Library Fedespedi.
                        </p>
                        <div className="d-flex justify-content-start">
                            <Button href='https://elibrary.fedespedi.it/' variant='light'>Accedi</Button>
                        </div>
                    </Alert>

                </Container></> : null}



        </>
    )
};